import { z } from 'zod';

// ── Billing run history + skips (T-071) ──────────────────────────────
// A skipped row recorded for a billing run: which row, who, and why.
export const BillingRunSkip = z.object({
  row_number: z.number().int(),
  worker: z.string(),
  reason: z.string(),
});
export type BillingRunSkip = z.infer<typeof BillingRunSkip>;

// One past billing run with its summary counts and its skipped rows nested.
export const BillingRun = z.object({
  id: z.string().uuid(),
  period: z.string(),
  rows_in: z.number().int().nonnegative(),
  rows_out: z.number().int().nonnegative(),
  rows_skipped: z.number().int().nonnegative(),
  created_at: z.string(),
  skips: z.array(BillingRunSkip),
  // Whether the run's output rows are stored (T-111). Runs recorded before the
  // billing_run_rows migration have none — no re-download / referral reports.
  has_rows: z.boolean(),
});
export type BillingRun = z.infer<typeof BillingRun>;

export const BillingRunsResponse = z.object({
  runs: z.array(BillingRun),
});
export type BillingRunsResponse = z.infer<typeof BillingRunsResponse>;

// ── Referral reports (T-111) ─────────────────────────────────────────
// Per-referrer slice of a stored run: how many of the run's rows belong to
// engagements CURRENTLY referred by that vendor (attribution is read at
// request time, so a T-110 backfill done after the run still counts).
export const ReferralSummaryVendor = z.object({
  id: z.string().uuid(),
  business_name: z.string(),
  rows: z.number().int().nonnegative(),
  workers: z.number().int().nonnegative(),
  // All-time referred engagements for context (the in-app "master list" size).
  total_referred_engagements: z.number().int().nonnegative(),
});
export type ReferralSummaryVendor = z.infer<typeof ReferralSummaryVendor>;

export const ReferralSummaryResponse = z.object({
  run_id: z.string().uuid(),
  period: z.string(),
  vendors: z.array(ReferralSummaryVendor),
});
export type ReferralSummaryResponse = z.infer<typeof ReferralSummaryResponse>;
